import { FC } from "react"
import { PointsBrewingInfo } from "@/types/points"
import { formatThousand } from "@/utils/util"

interface Props {
  className?: string
  info: PointsBrewingInfo
}

const BrewingItem: FC<Props> = ({ className, info }) => {
  return (
    <figure className={`m-0 p-[8px] pb-0 bg-[#f6f7f8] rounded-[24px] text-center ${className}`}>
      <div className="w-[106px] h-[106px] rounded-[16px] overflow-hidden">
        <nft-viewer
          type="image"
          src={ info.tokenImage }></nft-viewer>
      </div>
      <figcaption className="py-[16px]">
        <p className="m-0 text-[14px] leading-[16px] text-black font-medium">Token #{info.token}</p>
        <h3 className="m-0 mt-[8px] flex items-baseline justify-center text-[18px] leading-[21px] font-black text-black">
          <span>{ formatThousand(info.income) }</span>
          <span className="ml-[4px] text-[14px] font-bold">DAYS</span>
        </h3>
      </figcaption>
    </figure>
  )
}

export default BrewingItem
